import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Area } from "../models/Area";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { colors, fonts } from "../utils/colors";

interface FooterNavProps {
  areas: Area[];
  isLoggedIn: boolean;
  noActivePeriod?: boolean;
}

const FooterNav: React.FC<FooterNavProps> = ({ areas, isLoggedIn, noActivePeriod }) => {
  const location = useLocation();
  if (!isLoggedIn) return null;

  const footerBase: React.CSSProperties = {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    backgroundColor: colors.darkBlue,
    color: colors.white,
    padding: "14px 28px",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    zIndex: 1100,
    fontFamily: fonts.main,
  };

  const linkStyle: React.CSSProperties = {
    color: colors.green,
    textDecoration: "none",
    fontWeight: 600,
    alignItems: "center",
    display: "flex",
    transition: "color 0.2s ease",
  };

  // If inactive period: show footer shell without navigation links
  if (noActivePeriod) {
    return (
      <footer style={{ ...footerBase, justifyContent: "center" }}>
      </footer>
    );
  }

  const areaMatch = location.pathname.match(/^\/areas\/(\d+)/);
  const currentId = areaMatch ? Number(areaMatch[1]) : null;
  const onAreaPage = !!areaMatch;
  const index = currentId != null ? areas.findIndex(a => a.areaId === currentId) : -1;

  const prevArea = onAreaPage && index > 0 ? areas[index - 1] : null;
  const nextArea =
    onAreaPage && index > -1 && index < areas.length - 1
      ? areas[index + 1]
      : !onAreaPage && areas.length > 0
      ? areas[0]
      : null;

  return (
    <footer style={{ ...footerBase, justifyContent: "space-between" }}>
      {/* Left */}
      {prevArea ? (
          <Link to={`/areas/${prevArea.areaId}`} style={linkStyle}>
            <ArrowBack style={{ marginRight: 5 }} />
            {prevArea.areaName}
          </Link>
        ) : (
          <Link to="/" style={linkStyle}>
            {/* <ArrowBack style={{ marginRight: 5 }} /> Home */}
          </Link>
        )}

      {/* Center */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          fontWeight: 600,
          fontSize: ".85rem",
          letterSpacing: ".5px",
          color: colors.lightGray,
          textAlign: "center",
          maxWidth: "40%",
          fontFamily: fonts.main,
        }}
      >
        {onAreaPage && index > -1
          ? `Area ${index + 1}/${areas.length}: ${areas[index].areaName}`
          : ""}
      </div>

      {/* Right */}
      {nextArea ? (
        <Link to={`/areas/${nextArea.areaId}`} style={linkStyle}>
          {nextArea.areaName} <ArrowForward style={{ marginLeft: 5 }} />
        </Link>
      ) : onAreaPage ? (
        <Link to="/" style={linkStyle}>
          Home <ArrowForward style={{ marginLeft: 5 }} />
        </Link>
      ) : (
        <span style={{ color: colors.mediumGray, fontWeight: 500 }}>No areas</span>
      )}
    </footer>
  );
};

export default FooterNav;